module.exports = __webpack_public_path__ + "static/media/icon_star_n.1be37d3e.svg";